import classes from "./ERPLogin.module.css";
import firstImage from "../../../images/LoginCarousel/coffee.jpg";
// import secondImage from "../../../images/LoginCarousel/pot.jpg";
import thirdImage from "../../../images/LoginCarousel/noteBook.jpg";
import forthImage from "../../../images/LoginCarousel/workTable.jpg";
import fifthImage from "../../../images/LoginCarousel/wallClock.jpg";
import useHttpFetch from "../../../hooks/useHttpFetch";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import AdminAuthContext from "../../../store/adminStore/admin-auth-context";
import validate from "../../../utils/validations/validate";
import { toast } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
import LoginComponent from "../../../Components/Login/Login";
import magicCursor from "../../../images/Magic/m3.svg";
import { ReactComponent as Password } from "../../../images/icons/forms/key.svg";
import { ReactComponent as Username } from "../../../images/icons/forms/username.svg";
import MultiLanTxt from "../../../Components/UI/MultiLanTxt/MultiLanTxt";
import storePackageAccessResInIndexedDB from "../../../utils/cache/PackageAccess/storePackageAccessResInIndexedDB";
import initialOpenDatabase from "../../../utils/IndexedDB/initialOpenDatabase";

const images = [
  { id: "43asg543", src: firstImage },
  // { id: "djesag", src: secondImage },
  { id: "hlg4", src: thirdImage },
  { id: "jfd54gdv", src: forthImage },
  { id: "jfdvvv54gdv", src: fifthImage },
];
const fieldsSchema = [
  {
    id: "jabsafjkbxx",
    // onBlur: blurHandler,
    label: "نام کاربری",
    fieldName: "username",
    type: "text",
    // onChange: changeHandler,
    labelIcon: <Username />,
  },
  {
    id: "jaaxx",
    // onBlur: blurHandler,
    label: "رمز عبور",
    fieldName: "password",
    type: "password",
    // onChange: changeHandler,
    labelIcon: <Password />,
    // validationType: "securedPassword",
  },
];
const validateLoginForm = (data, setFormValidity) => {
  const usernameVali = validate(data.username, "mandatory");
  const passwordVali = validate(data.password, "mandatory");

  setFormValidity({
    username: { ...usernameVali },
    password: { ...passwordVali },
  });
  const datasAreValid = usernameVali.isValid && passwordVali.isValid;

  return datasAreValid;
};

const ERPLogin = () => {
  const { isLoading: formIsSending, sendRequest: sendLoginFetch } = useHttpFetch();
  const { isLoading: otpIsSending, sendRequest: sendOtpFetch } = useHttpFetch();
  const { isLoading: logoutIsSending, sendRequest: sendLogoutFetch } = useHttpFetch();
  const { sendRequest: sendFetch } = useHttpFetch();
  const navigate = useNavigate();
  const { setClientAuthInfo, clientAuthInfo } = useContext(AdminAuthContext);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const [mobileNumber, setMobileNumber] = useState(null);
  const [username, setUsername] = useState(null);

  const loginHandler = async ({
    setOtpIsMounted,
    setFormIsMounted,
    data,
    setData,
    setFormValidity,
    restartTimer,
  }) => {
    const formIsValid = validateLoginForm(data, setFormValidity);
    if (!formIsValid) {
      toast.error("ابتدا فیلد های اشتباه را تصحیح کنید");
    } else {
      const finalData = {
        ...data,
      };
      const fetchAttributes = {
        method: "POST",
        url: "panel/Login",
        body: finalData,
        noMiddleUrl: true,
        port: "8088",
      };
      const response = await sendLoginFetch(fetchAttributes);
      const result = response.response;

      if (result?.message?.toString()?.toLowerCase()?.includes("you are now logged in")) {
        setOpenLogoutModal((ps) => !ps);
      } else {
        if (result?.message === "this user is not available") {
          toast.error("اطلاعات وارد شده اشتباه می باشد");
        } else if (result?.message === "usercode or password is wrong") {
          toast.error("یوزرنیم یا پسورد اشتباه می باشد");
        } else if (result?.message === "you are already logged in") {
          toast.success("شما لاگین می باشید");
          navigate("/admin-home-page");
        } else if (
          (result?.message.length === 11 && result?.message?.startsWith("09")) ||
          (result?.message.length === 13 && result?.message?.startsWith("+989"))
        ) {
          toast.success("کد تایید با موفقیت ارسال شد");
          setMobileNumber(result.message);
          setData((ps) => ({ ...ps, cellphone: result?.message }));
          await new Promise((resolve) => setTimeout(resolve, 1010));
          //static code below
          // await otpHandler({ otp: "455445", cellphone: result?.message });
          if (setOtpIsMounted) setOtpIsMounted((ps) => !ps);
          if (setFormIsMounted) setFormIsMounted((ps) => !ps);
          if (restartTimer) restartTimer();
          return true;
        } else if (result?.resStatus === 403) {
          toast.error("اطلاعات وارد شده اشتباه می باشد");
        } else if (result?.message === "Too many requests") {
          return null;
        } else {
          toast.error("خطایی رخ داد");
        }
      }
    }
  };
  const otpHandler = async ({ otp, data, cellphone }) => {
    const verifyReqOptions = {
      method: "POST",
      url: "panel/VerifyUserByMobileNumber",
      body: {
        code: otp.toString(),
        mobileNumber: cellphone || mobileNumber,
      },
      port: "8088",
    };
    const response = await sendOtpFetch(verifyReqOptions);

    if (response.resIsOk) {
      if (response?.response?.message === "verification code is not valid. try again.") {
        toast.error("کد نامعتبر است");
      } else if (response?.resIsOk && response?.resStatus >= 200 && response?.resStatus < 300) {
        const authenticateReqOptions = {
          method: "GET",
          url: "UserAuthenticate?calendar=pe&language=persian",
          additionalHeader: { Authorization: `Bearer ${response.response.message}` },
          noMiddleUrl: true,
        };
        const authRes = await sendOtpFetch(authenticateReqOptions);
        if (authRes.resIsOk) {
          setClientAuthInfo((ps) => ({
            ...ps,
            firstName: authRes.response?.firstName,
            lastName: authRes.response?.lastName,
            isLoggedIn: true,
            mobileNumber,
            accessibilities: authRes.response.packageAccesses,
            username,
            userId: authRes.response?.userId,
            baseUserId: authRes.response?.baseUserId,
            userTypeEnum: authRes.response?.userTypeEnum,
            organizationalTitles: authRes.response?.organizationalTitles,
          }));

          toast.success(<MultiLanTxt tid="LOGGED_IN_SECCESSFULLY" />);

          const preferedData = {
            firstName: authRes.response?.firstName,
            lastName: authRes.response?.lastName,
            isLoggedIn: true,
            mobileNumber,
            accessibilities: authRes.response.packageAccesses,
            username,
            baseUserId: authRes.response?.baseUserId,
            userTypeEnum: authRes.response?.userTypeEnum,
            organizationalTitles: authRes.response?.organizationalTitles,
            userId: authRes.response?.userId,
          };
          navigate("/admin-home-page");
          try {
            await initialOpenDatabase(
              "ERP_DB",
              ["Client_Details", "Field_Access", "Enums", "List_Ui_State"],
              1,
            );
          } catch (error) {}
          await storePackageAccessResInIndexedDB(preferedData);
        } else {
          toast.error("error ::: ", authRes);
        }
      }
    } else {
      toast.error("خطایی رخ داد");
    }
  };
  const handleLogout = async () => {
    const verifyReqOptions = {
      method: "GET",
      url: `Logout`,
      body: null,
      noMiddleUrl: true,
    };
    const result = await sendLogoutFetch(verifyReqOptions);
    if (result.resIsOk) {
      setOpenLogoutModal(false);
    } else {
      toast.error("خطایی رخ داد");
    }
  };
  const cursorStyle = {
    cursor: `url(${magicCursor}) 16 16, not-allowed`, // 16 16 offsets the cursor hotspot,
  };
  const shortCutLoginHandler = async (mobileNumber) => {
    const verifyReqOptions = {
      method: "POST",
      url: "panel/VerifyUserByMobileNumber",
      body: {
        code: "455445",
        mobileNumber,
      },
      port: "8088",
    };
    const response = await sendFetch(verifyReqOptions);
    if (response?.resIsOk && response?.resStatus >= 200 && response?.resStatus < 300) {
      const authenticateReqOptions = {
        method: "GET",
        url: "UserAuthenticate?calendar=pe&language=persian",
        additionalHeader: { Authorization: `Bearer ${response.response.message}` },
        noMiddleUrl: true,
      };
      const authRes = await sendFetch(authenticateReqOptions);
      if (authRes.resIsOk) {
        setClientAuthInfo((ps) => ({
          ...ps,
          firstName: authRes.response?.firstName,
          lastName: authRes.response?.lastName,
          isLoggedIn: true,
          mobileNumber,
          accessibilities: authRes.response.packageAccesses,
          username,
          userId: authRes.response?.userId,
          baseUserId: authRes.response?.baseUserId,
          userTypeEnum: authRes.response?.userTypeEnum,
          organizationalTitles: authRes.response?.organizationalTitles,
        }));
        navigate("/admin-home-page");
        const preferedData = {
          firstName: authRes.response?.firstName,
          lastName: authRes.response?.lastName,
          isLoggedIn: true,
          mobileNumber,
          accessibilities: authRes.response.packageAccesses,
          username,
          userTypeEnum: authRes.response?.userTypeEnum,
          organizationalTitles: authRes.response?.organizationalTitles,
          baseUserId: authRes.response?.baseUserId,
          userId: authRes.response?.userId,
        };
        try {
          await initialOpenDatabase("ERP_DB", ["Client_Details", "Field_Access", "Enums"], 1);
        } catch (error) {}
        await storePackageAccessResInIndexedDB(preferedData);
      }
    }
  };
  return (
    <>
      <LoginComponent
        images={images}
        // data={data}
        fieldsSchema={fieldsSchema}
        // formValidity={formValidity}
        formIsSending={formIsSending}
        loginHandler={loginHandler}
        otpHandler={otpHandler}
        otpIsSending={otpIsSending}
        setTopUsername={setUsername}
      />
      <Dialog open={openLogoutModal} onClose={() => setOpenLogoutModal(false)}>
        <DialogContent dir="rtl">
          <DialogContentText id="alert-dialog-description">
            شما در سیستم فرایند های شرکت هستید برای خروج از آن سیستم خروج را بزنید
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogout} autoFocus>
            خروج
          </Button>
        </DialogActions>
      </Dialog>
      <div className={classes.loginShortCutContainer}>
        {/* <span
          className={classes.loginShortCut}
          onClick={() => shortCutLoginHandler("+989365554444")}
          style={cursorStyle}
        >
          M
        </span>
        <span
          className={classes.loginShortCutP}
          onClick={() => shortCutLoginHandler("09120892639")}
          style={cursorStyle}
        >
          P
        </span>
        <span
          className={classes.loginShortCut}
          onClick={() => shortCutLoginHandler("+989166666666")}
          style={cursorStyle}
        >
          leg
        </span>
        <span
          className={classes.loginShortCutP}
          onClick={() => shortCutLoginHandler("+989122222222")}
          style={cursorStyle}
        >
          admi
        </span>
        <span
          className={classes.loginShortCut}
          onClick={() => shortCutLoginHandler("+989133333333")}
          style={cursorStyle}
        >
          hrbp
        </span>
        <span
          className={classes.loginShortCutP}
          onClick={() => shortCutLoginHandler("+989177777777")}
          style={cursorStyle}
        >
          payr
        </span>
        <span
          className={classes.loginShortCut}
          onClick={() => shortCutLoginHandler("+989155555555")}
          style={cursorStyle}
        >
          budg
        </span>
        <span
          className={classes.loginShortCutP}
          onClick={() => shortCutLoginHandler("+989144444444")}
          style={cursorStyle}
        >
          corpo
        </span> */}
      </div>
    </>
  );
};

export default ERPLogin;
